import { DateTime } from "luxon";

export default function getWeekDays(lastDay: DateTime, numDays = 7) {
  const dates: { date: DateTime; data: any[] }[] = [];
  for (let index = 0; index < numDays; index++) {
    dates.push({ date: lastDay.minus({ days: index }), data: [] });
  }
  return dates.reverse();
}
